import useNavigate from 'utils/useNavigate';
import Cookies from 'js-cookie';
import { FormRedirect } from 'components/Form/DemoForm/FormRedirect';

const FORMDemoRequest2021Condensed = data => {
  const customDQFlowIndustries = [
    'HVAC',
    'Plumbing',
    'Electrical',
    'Garage Door',
    'Water Treatment',
    'Carpet Cleaning',
    'Duct Cleaning',
    'Landscaping',
    'Irrigation',
    'Elevator & Escalator',
    'Chimney Sweep and Hearth',
    'Janitorial Services',
    'Glass Installation',
    'Window Cleaning',
    'Security Systems',
    'Resoration',
    'Pool/Spa',
    'Septic',
  ];
  const newMarkets = ['Lawn Care Services', 'Pest Control', 'Tree Services'];

  return !customDQFlowIndustries.includes(data?.Primary_Industry__c) &&
    !customDQFlowIndustries.includes(data?.industryTestVerticals) &&
    !newMarkets.includes(data?.industryTestVerticals)
    ? 'thankyoudemo-industry'
    : newMarkets.includes(data?.industryTestVerticals) &&
      data?.Estimated_Total_Potential_Office__c >= 0
    ? 'thankyoudemo'
    : data?.Estimated_Total_Potential_Office__c < 1
    ? 'thankyoudemo-size'
    : 'thankyoudemo';
};

const FORMTitanRefer = data => {
  data.areaOfFocus = data.BusinessFocus__c;
  data.industry =
    data.Primary_Industry__c === 'Other' ? data.industryTestVerticals : data.Primary_Industry__c;
  data.typeOfBusiness = data.BusinessFocus__c;
  data.techs = data.No_of_Technicians__c;
  data.officeStaff = data.Estimated_Total_Potential_Office__c;

  FormRedirect('normal', data);
};

export const handleCustomDQ = (data, marketoFormId) => {
  if (marketoFormId === 3527) {
    FORMTitanRefer(data);
  } else {
    const slug = marketoFormId === 3457 ? FORMDemoRequest2021Condensed(data) : null;

    if (!slug) return;

    Cookies.set('access-permission', slug);
    useNavigate(`/${slug}`);
  }
};
